import { isUndefined } from '@sonar-software/sonar-ts-lib';
import { LoadingDots } from '@ui/general';
import { useOnMount } from '@hooks';
import React, { useState } from 'react';
const wrapperStart = (name) => `${name} (`;
const wrapperEnd = ')';
export const PeriscopeMenuLabel = ({ count, name }) => {
    const [countValue, setCountValue] = useState(count);
    const [isLoading, setIsLoading] = useState(true);
    useOnMount(() => {
        Promise.resolve(count).then((value) => {
            setCountValue(value);
            setIsLoading(false);
        });
    });
    if (isUndefined(count)) {
        return name;
    }
    if (isLoading) {
        return (React.createElement(React.Fragment, null,
            wrapperStart(name),
            React.createElement(LoadingDots, null),
            wrapperEnd));
    }
    return `${name} (${countValue !== null && countValue !== void 0 ? countValue : 0})`;
};
